<template>
  
    <!-- upload icon  v-upload="appendFiles"-->
    <div class="column pointer click center" >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.2127 9.78701C12.8979 9.47209 12.5242 9.22228 12.1128 9.05185C11.7014 8.88141 11.2605 8.79369 10.8152 8.79369C10.3699 8.79369 9.92903 8.88141 9.51766 9.05185C9.10629 9.22228 8.73253 9.47209 8.41772 9.78701L4.99272 13.213C4.357 13.8489 3.99991 14.7112 4 15.6104C4.00009 16.5095 4.35737 17.3718 4.99322 18.0075C5.62908 18.6432 6.49143 19.0003 7.39058 19.0002C8.28972 19.0001 9.152 18.6429 9.78772 18.007L10.1087 17.703M9.78772 13.213C10.1025 13.5279 10.4763 13.7777 10.8877 13.9482C11.299 14.1186 11.7399 14.2063 12.1852 14.2063C12.6305 14.2063 13.0714 14.1186 13.4828 13.9482C13.8942 13.7777 14.2679 13.5279 14.5827 13.213L18.0067 9.78701C18.6426 9.15128 18.9999 8.289 18.9999 7.38986C19 6.49072 18.6429 5.62836 18.0072 4.99251C17.3715 4.35665 16.5092 3.99938 15.6101 3.99928C14.7109 3.99919 13.8486 4.35628 13.2127 4.99201L12.1847 5.95301" stroke="#666666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>                          
    </div>

</template>
<script>
/* eslint-disable */
import { defineComponent } from 'vue';
export default defineComponent({  
  
  data() {
    return {}
  },
 
});

</script>
